'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    /* jshint ignore:start */
    gtm_dialog = require('int_googletagmanager/linchpin/dialog'),
    /* jshint ignore:end */
    progress = require('./progress');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        var $target, id, selector;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                selector = params.target;
                $target = $(selector);
            } else {
                selector = '#' + params.target;
                $target = $(selector);
            }
        } else if (params.target instanceof jQuery && params.target.length > 0) {
            $target = params.target;
        } else {
            selector = '#dialog-container';
            $target = $(selector);
        }

        // if no element found, create one
        if ($target.length === 0) {
            if (selector && selector.charAt(0) === '#') {
                id = selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }
        // when more dialogs opens make sure to keep
        // handling for them
        if (this.$container) {
            this.multipleDialogs = true;
        }
        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
        var position = params.options && params.options.position ? params.options.position : this.settings.position;
        $(window).smartresize(function () {
            $target.dialog('option', 'position', position);
        });
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */

    open: function (params) {
        // close any open dialog
        if (params.allowMultipleDialogs !== true) {
            // close any open dialog
            this.close();
        }
        this.create(params);
        this.replace(params);
        /* jshint ignore:start */
        gtm_dialog.saveHamper(params);
        /* jshint ignore:end */
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params) {
        var content, position, callback;

        if (!this.$container) { return; }
        content = params.content || params.html;
        if (!content) { return; }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
            if (params.options.buttons) {
                this.$container.dialog('option', 'buttons', params.options.buttons);
            }
            if (params.options.title) {
                this.$container.dialog('option', 'title', params.options.title);
            }
        }
        if (!position) {
            position = this.settings.position;
        }

        var self = this;
        var $images = $(self.$container).find('img:visible');
        var totalImages = $images.length;
        if (totalImages) {
            var loadedCount = 0;
            $images.each(function() {
                var img = $(this);
                if (img.complete) {
                    loadedCount++;
                } else {
                    img.on('load', function() {
                        loadedCount++;
                        if (loadedCount === totalImages) {
                            self.$container.dialog('option', 'position', position);
                        }
                    });
                }
            });
        }

        callback = (typeof params.callback === 'function') ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
        if (this.multipleDialogs) {
            $('.ui-dialog-content').dialog('close');
            this.multipleDialogs = false;
        }
    },
    /**
     * @function
     * @description Submits the dialog form with the given action
     * @param {String} The action which will be triggered upon form submit
     */
    submit: function (action, callback) {
        var $form = this.$container.find('form:first');
        var $dialogWrapper = this.$container.closest('.ui-dialog');
        var showLoading = $dialogWrapper.hasClass('dialog-show-loading');
        // set the action
        $('<input/>').attr({
            name: action,
            type: 'hidden'
        }).appendTo($form);
        // serialize the form and get the post url
        var data = $form.serialize();
        var url = $form.attr('action');
        // make sure the server knows this is an ajax request
        if (data.indexOf('ajax') === -1) {
            data += '&format=ajax';
        }
        // Display loading progress for dialog with "dialog-show-loading" class
        if (showLoading) {
            progress.show($dialogWrapper, 'loader-alt');
        }

        // post the data and replace current content with response content
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'html'
        }).done(function (html) {
            this.$container.html(html);
            if (callback) {
                callback();
            }
        }.bind(this)).fail(function () {
            window.alert(Resources.SERVER_ERROR);
        }).always(function () {
            if (showLoading) {
                progress.hide($dialogWrapper);
            }
        });
    },

    cmsPageInPopUp: function (url, btns) {
        if (typeof url === 'undefined') {
            return;
        }
        if (typeof btns === 'undefined') {
            btns = [{
                'text': Resources.GOT_IT,
                'class': 'button-black got-it',
                click: function () {
                    $(this).dialog('close');
                }
            }];
        }
        this.open({
            url: url,
            options: {
                buttons: btns,
                dialogClass:'cms-page-dialog no-title'
            }
        });
    },
    tooltip: function (html, container) {
        if ($(document).data('ui-tooltip')) {
            $(document).tooltip('disable');
        }
        this.open({
            target: container,
            html: html,
            options: {
                dialogClass: 'cms-page-dialog no-title',
                buttons: [{
                    'text': Resources.GOT_IT,
                    'class': 'button-black got-it',
                    click: function () {
                         $(this).dialog('close');
                    }
                }],
                close: function () {
                    if ($(document).data('ui-tooltip')) {
                        $(document).tooltip('enable');
                    }
                }
            },
            allowMultipleDialogs: true
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        //width: '800',
        close: function () {
            $(this).dialog('close');
        },
        buttons:[],
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;
